export class User {
  user_id?: number
  full_name?: string
  username?: string
  email?: string
  password?: string
  role?: string
}
